let current;
let last=null;
let last2=null;
function closeMenu(msg=null){
     let menu = document.querySelector('.top-menu');
    //  if(current && current.querySelector(':hover')) return;
    //  if(menu.querySelector('.sub-menu :hover')){ return ; }
     if(menu.querySelector(':hover')) { clearTimeout(last); return };
     
     console.log('LS: hover not detected');
     current=null;
    closeAll(msg);
}

function closeAll(msg=null){
    if(last) clearTimeout(last);
    let menu = document.querySelector('.top-menu');
    //console.log('top-menu: close all ' +  msg);
    menu.querySelectorAll('.js-sub-menu').forEach((m,event)=>{
        if(m.style.display=='block'){
            m.style.display='none';
            m.previousElementSibling.classList.remove('active','hover','click');
            m.previousElementSibling.setAttribute('aria-expanded',"false");
        }
    });
    
}

function listenMobileToggle(event){
    h=event.currentTarget;
    
    let m = document.getElementById('mobile_top_menu_wrapper');
    if(!m) return;
    let s = m.style.display;
    let w = document.getElementById('wrapper');
    let f = document.getElementById('footer');
    if(s=='block'){
        m.style.display='none';
        if(f) f.style.display='block';   
        if(w) w.style.display='block';   
    }else{
        m.style.display='block';
        if(f) f.style.display='none';   
        if(w) w.style.display='none';  
    }
}

function listenMenuMouse(event){
    let menu = document.querySelector('.top-menu');
    /** @type {HTMLElement} */

    if(!menu) return;
    let e = event.target;

    let e1=e.parentNode;
    let e2=e1.parentNode;
    if(e1.classList.contains('dropdown-item')) e=e1;
    else if(e2.classList.contains('dropdown-item')) e=e2;

     if(!e.classList.contains('dropdown-item') || e.getAttribute('data-depth')!=0) return;
     
     if(e!=current) last=setTimeout(closeMenu,600,'current ! = last');

     current=e;
    if(last2) clearTimeout(last2);
    last2=setTimeout(()=>{
        //if hover changed cancel
        if(e.matches(':hover') || e.querySelector(':hover')){
            console.log('top-menu: open');
            //pending close
            if(!e.nextElementSibling)  { closeAll(' phanto '); return ; }
            let s= e.nextElementSibling.style.display;
            if(last) clearTimeout(last);

             if(s!='block'){
                closeAll('opening new');
                //close any but if 
                if( e.nextElementSibling){
                    e.nextElementSibling.style.display='block';
		            e.setAttribute('aria-expanded','true');
        	        e.classList.add('active','hover'); //block click close
                }
            }
        }
    },400);
}

function listenMenuToggle(event){
    
    // if(last) clearTimeout(last);
    // last=setTimeout(closeMenu,600,'menu toggle');
    
    // console.log('event: '+event);

    li=event.currentTarget;

    let ul =li.parentNode.querySelector('.js-sub-menu');

     if(!ul || li.getAttribute('data-depth')>0) return;
     current=li;
    let style=ul.style.display;

    // if(style=='block' && li.classList.contains('hover')) return; //prevent fast close

     if(last) clearTimeout(last);
    if(last2) clearTimeout(last2);
    closeAll('click dropdown');

    if(style!='block'){
        li.classList.add('active','click');
        li.setAttribute('aria-expanded',true);
        ul.style.display='block';
    }else{
        li.classList.remove('active');
        li.setAttribute('aria-expanded',false);
        ul.style.display='none';
    }
 
    event.stopPropagation();
    event.preventDefault();
    return true;
}

window.addEventListener('load',()=>{
    console.log('LS: top-menu.js load');
    let menu = document.querySelector('.top-menu');

    menu.querySelectorAll('.dropdown-item').forEach((li)=>{
        li.addEventListener('click',listenMenuToggle);
    });


    menu.querySelectorAll('.sub-menu, .dropdown-item').forEach((m)=>{
        m.addEventListener('mouseleave',()=>{

        if(!menu.parentNode.classList.contains('mobile')){
            if(last) clearTimeout(last);
            last=setTimeout(closeMenu,600,' mouseleave');
        }
        });
    });

    let h = document.getElementById('menu-icon');
    h.addEventListener('click',listenMobileToggle);

    window.addEventListener('click',(event)=>{
        if(!event.target.closest('.top-menu'))
            closeAll('click');
    });

    if(!menu.parentNode.classList.contains('mobile')){
        menu.addEventListener('mousemove',listenMenuMouse);
    }


});


document.addEventListener('click',(event)=>{
    if(event.target=='A') return;
});
